import { useQuery } from "@tanstack/react-query"
import i18next from "i18next"

import { LanguageIso6391 } from "@tfg/types/schemas/enum"
import { FindBatchUpdateOperationsRequestDto } from "@tfg/types/schemas/modules/traceability/queries/find-batch-update-operations.request.dto"

import { httpClient } from "~/backend/axios.ts"

type useFindBatchOperationsHookProps = {
  update: Omit<FindBatchUpdateOperationsRequestDto, "userEmail">
  searchProduct: string
  fetchDataOptions: {
    pageIndex: number
    pageSize: number
  }
  enabled: boolean
}
export function useFindBatchOperationsHook({
  update,
  searchProduct,
  fetchDataOptions,
  enabled,
}: useFindBatchOperationsHookProps) {
  return useQuery({
    queryKey: [
      "find-batch-operations",
      update,
      searchProduct,
      fetchDataOptions,
    ],
    queryFn: async () => {
      const response = await httpClient.post(
        "/supplier-traceability/find-batch-operations",
        {
          ...update,
          searchProduct,
          fetchDataOptions,
        },
        {
          headers: {
            "accept-language":
              i18next.language.toUpperCase() ?? LanguageIso6391.EN,
          },
        }
      )
      return response.data
    },
    enabled,
  })
}
